import { createContext } from "react";
import { Context } from "../global";

const Guesses = createContext<Context|null>(null)
export default Guesses;